document.addEventListener("DOMContentLoaded", () => {

  // Tabs auto init
  document.querySelectorAll(".sg-tabs").forEach((tabs) => {
    const defaultTab = tabs.dataset.defaultTab;
    const buttons = tabs.querySelectorAll(".sg-tab-btn");
    const panels = tabs.querySelectorAll(".sg-tab-panel");

    function activate(tabName) {
      buttons.forEach((b) =>
        b.classList.toggle("is-active", b.dataset.tab === tabName)
      );
      panels.forEach((p) =>
        p.classList.toggle("is-active", p.dataset.panel === tabName)
      );
    }

    if (defaultTab) {
      activate(defaultTab);
    } else if (buttons.length) {
      activate(buttons[0].dataset.tab);
    }

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => activate(btn.dataset.tab));
    });
  });

  // Sidebar scroll + open accordion
  const links = document.querySelectorAll(".sg-link");
  const allAccordions = document.querySelectorAll(".sg-accordion-item");

  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const id = link.getAttribute("href");
      const target = document.querySelector(id);
      if (!target) return;

      // Hide all accordions first
      allAccordions.forEach((acc) => {
        acc.classList.add("sg-hidden");
        acc.open = false;
      });

      // Show and open only the clicked one
      target.classList.remove("sg-hidden");
      target.open = true;
      target.scrollIntoView({ behavior: "smooth", block: "start" });

      links.forEach(l => l.classList.remove("is-active"));
      link.classList.add("is-active");
    });
  });

});